angular.module( 'acme.view.application.settlement.detail', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.view.application.settlement.detail.controllers',
    'acme.common.directive.transactionDisplay'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var settlementDetail = {
        name: 'application.settlement.detail',
        url: '/detail/:id',
        views: {
          "subview-main": {
            controller: 'SettlementDetailController',
            templateUrl: 'views/application/views/settlement/detail/detail.tpl.html'
          }
        },
        resolve: {
          CompanyData: [ 'ApiService', 'AuthService', function(ApiService, AuthService) {
              return ApiService.tenant.view(AuthService.getCookie('user').tenantId);
          }]
        },
        data: {
          pageTitle: 'Settlement Detail',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.settlement.detail') !== -1);
          }
        }
      };

    $stateProvider
      .state(settlementDetail);
});
